import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  partTitle: {
    fontWeight: 'bold',
    color: theme.palette.primary.dark,
    fontSize: 14,
  },
  partSubTitle: {
    color: theme.palette.gray[6],
    fontSize: 13,
  },
  partSubTitleError: {
    color: theme.palette.error.main,
  },
  oneTimeCheck: {
    background: theme.palette.gray[1],
    border: `1px solid ${theme.palette.gray[2]}`,
    borderRadius: 4,
    marginInlineStart: theme.spacing(0),
    paddingInlineEnd: theme.spacing(2),
  },
  select: {
    backgroundColor: '#eceff1',
  },
  info: {
    color: '#546e7a',
    fontSize: 12,
    marginBottom: theme.spacing(2.5),
  },
  infoIcon: {
    fontSize: 15,
    marginBottom: -4,
  },
  radioItem: {
    border: '1px solid #dfdfdf',
    borderRadius: 8,
    backrgound: 'white',
    boxSizing: 'border-box',
    display: 'block',
    padding: theme.spacing(1, 2),
    marginInlineStart: 0,
    transition: 'ease .2s background',
    '&.active': {
      background: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      color: 'white',
    },
    '&:first-child': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      borderRight: 'none',
    },
    '&:last-child': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      borderLeft: 'none',
    },
  },
  radioText: {
    color: '#2b3940',
    fontSize: 14,
    display: 'inline-block',
    transition: 'ease .2s color',
    fontWeight: 'bold',
    '&.active': {
      color: 'white',
    },
  },
  options: {
    '& label': {
      margin: 0,
    },
  },
}));